import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Argon from './plugins/argon-kit'
import './registerServiceWorker'
import AOS from 'aos'
import 'aos/dist/aos.css'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faUserSecret,
  faHeart,
  faDna,
  faPlug,
  faProjectDiagram,
  faCompressArrowsAlt,
  faRocket,
  faEnvelopeOpen,
  faCity,
  faCode,
  faCodeBranch,
  faDatabase,
  faHandshake,
  faHdd,
  faTerminal,
  faTimes,
  faPlus,
  faCogs,
  faCog,
  faServer,
  faCheck,
  faSearch,
  faUniversalAccess,
  faRecycle,
  faBook,
  faSyncAlt,
  faMap,
  faBicycle,
  faMagic
} from '@fortawesome/free-solid-svg-icons'
import {
  faTwitter,
  faGithub,
  faCodepen,
  faCloudsmith,
  faGitter,
  faLinkedin
} from '@fortawesome/free-brands-svg-icons'

library.add(
  faDna,
  faUserSecret,
  faHeart,
  faGithub,
  faTwitter,
  faPlug,
  faProjectDiagram,
  faCompressArrowsAlt,
  faRocket,
  faEnvelopeOpen,
  faCodepen,
  faCity,
  faCode,
  faCodeBranch,
  faDatabase,
  faHandshake,
  faHdd,
  faTerminal,
  faTimes,
  faPlus,
  faCogs,
  faCog,
  faCloudsmith,
  faGitter,
  faServer,
  faLinkedin,
  faCheck,
  faSearch,
  faUniversalAccess,
  faRecycle,
  faBook,
  faSyncAlt,
  faMap,
  faBicycle,
  faMagic
)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(Argon)
Vue.config.productionTip = false
new Vue({
  created() {
    AOS.init()
  },
  router,
  render: h => h(App)
}).$mount('#app')
